/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import DeviceForm from './DeviceForm';
import { getAllDevice } from '../../../../../../store/reducers/device/deviceAction';
import { createDevice } from '../../../../../../services/device/Device';
import { getAllOrg } from '../../../../../../store/reducers/organization/organizationAction';


const DeviceCreation = ({  handleClose }) => {
    const dispatch = useDispatch()
    useEffect(()=>{
        dispatch(getAllOrg())
    },[dispatch]);
    const handleSubmit = async ({ deviceName,deviceUID,deviceOwnerID }) => { 
        try{
            await createDevice({  deviceName,deviceUID,deviceOwnerID });
            handleClose();
            await dispatch(getAllDevice()).unwrap();
            toast.success('Device was registred successfully');

        }catch(error){
            toast.error(error?.response?.data?.error?.message);
        } 
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Device Registration</Typography>
            <Formik
                initialValues={{
                    deviceName: '',
                    deviceUID: '',
                    deviceOwnerID:''
                }}
                validationSchema={Yup.object().shape({
                    deviceName: Yup.string().min(2).max(40).required('Device Name is required.'),
                    deviceUID: Yup.string().min(2).max(64000).required('Device UID is required.'),
                    deviceOwnerID: Yup.string().required('Owner is required.')
                })}
                onSubmit={(
                    values
                ) => {
                    handleSubmit(values)
                }
                }
            >
                 {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <DeviceForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}

 
export default DeviceCreation;